import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ProfileProvider } from "@/context/ProfileContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { RequireProfile } from "@/components/auth/Guards";
import { AppShell } from "@/components/layout/AppShell";
import Home from "@/pages/Home";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import Onboarding from "@/pages/Onboarding";
import MusicPage from "@/pages/Music";
import TrackPage from "@/pages/TrackPage";
import UploadPage from "@/pages/Upload";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import VideosPage from "@/pages/Videos";
import WatchPage from "@/pages/Watch";
import ShortsPage from "@/pages/Shorts";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

const members = (el) => <RequireProfile>{el}</RequireProfile>;

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <ProfileProvider>
          <PlayerProvider>
            <Routes>
              <Route element={<AppShell />}>
                <Route path="/" element={<Home />} />
                <Route path="/music" element={members(<MusicPage />)} />
                <Route path="/videos" element={members(<VideosPage />)} />
                <Route path="/watch/:id" element={members(<WatchPage />)} />
                <Route path="/shorts" element={members(<ShortsPage />)} />
                <Route path="/upload" element={members(<UploadPage />)} />
                <Route path="/track/:id" element={members(<TrackPage />)} />
                <Route path="/profile" element={members(<Profile />)} />
                <Route path="/u/:username" element={members(<PublicProfile />)} />
                <Route path="/payment/success" element={members(<PaymentSuccess />)} />
                <Route path="/payment/cancel" element={members(<PaymentCancel />)} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
            <Toaster theme="dark" position="top-center" />
          </PlayerProvider>
        </ProfileProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
